module.exports = __webpack_public_path__ + "img/motor_no65.d4288ad3.jpg";